import React, { useEffect } from 'react'
import { useState } from 'react';
import { Button, Card, Col, Divider, Form, Input, InputNumber, Popconfirm, Row, Select, Space, Tooltip, message, Modal, Checkbox, notification, Tabs, Skeleton } from 'antd'
import { useStoreActions, useStoreState } from '../../../../store/hooks/easyPeasy';
import { Table, Tag } from 'antd';
import TableView from '../../../../contents/AntTableResponsive';
import { DeleteOutlined, DownloadOutlined, EditOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons';
import Column from 'rc-table/lib/sugar/Column';
import { render } from '@testing-library/react';
import { SelectClassConfig } from '../../../select/SelectClassConfig';
import { v4 as uuidv4 } from "uuid";
import $ from 'jquery';
import jsPDF from "jspdf";
import { pdfDataL, ppowerdbypdf, pdatepdf } from '../../../utils/pdf';
import { FilePdfOutlined } from '@ant-design/icons';
import { SelectSection } from '../../../select/SelectSection';
import { SelectAcademicYear } from '../../../select/SelectAcademicYear';
import { SelectClass } from '../../../select/SelectClass';
require('jspdf-autotable');

export default function SectionWisePassFailSummary() {
    const { Option } = Select;
    const [examReportSectionWiseResultForm] = Form.useForm();

    const fetchPassFailSummaryExamList = useStoreActions((state) => state.exam.fetchPassFailSummaryExamList);
    const examPassFailSummaryExamList = useStoreState((state) => state.exam.examPassFailSummaryExamList);

    const fetchPassFailSummaryByAcademicYearExamidStudentList = useStoreActions((state) => state.exam.fetchPassFailSummaryByAcademicYearExamidStudentList);
    const passfailSummaryByAcademicYearExamidStudentList = useStoreState((state) => state.exam.passfailSummaryByAcademicYearExamidStudentList);

    useEffect(() => {
        fetchPassFailSummaryExamList();
    }, []);

    const unassignedSubjectMarkListColumn = [
        { title: 'Section', dataIndex: 'classConfigName', key: "classConfigName", showOnResponse: true, showOnDesktop: true },
        { title: 'Current Total Students', dataIndex: 'totalStudents', key: "totalStudents", showOnResponse: true, showOnDesktop: true },
        { title: 'Participated In Exam', dataIndex: 'participatedInExam', key: "participatedInExam", showOnResponse: true, showOnDesktop: true },
        { title: 'Pass', dataIndex: 'totalPass', key: "totalPass", showOnResponse: true, showOnDesktop: true },
        { title: 'Fail', dataIndex: 'totalFail', key: "totalFail", showOnResponse: true, showOnDesktop: true },
        { title: 'Pass Percentage', dataIndex: 'passPercentage', key: "passPercentage", showOnResponse: true, showOnDesktop: true },
        { title: 'Fail Percentage', dataIndex: 'failPercentage', key: "failPercentage", showOnResponse: true, showOnDesktop: true },
    ];
    const loading = useStoreState((state) => state.exam.loading);

    function exportPdf() {

        var doc = new jsPDF("l", "mm", "a4");

        var details = `Section Wise Pass Fail Summary`;
        pdfDataL(doc, "");
        doc.text(details, 150, 40, 'center');
        var totalPagesExp = "{total_pages_count_string}";

        var pageContent = function (data) {
            // FOOTER
            var str = ppowerdbypdf + data.pageCount;
            if (typeof doc.putTotalPages === 'function') {
                str = str + " of " + totalPagesExp + pdatepdf;
            }
            doc.setFontSize(8);
            var pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
            doc.text(str, data.settings.margin.right, pageHeight - 10);
        };


        var col = [
            "Section",
            "Current Total Students",
            "Participated In Exam",
            "Pass",
            "Fail",
            "Pass Percentage",
            "Fail Percentage",
        ].filter(Boolean);

        var rows: any = [];


        passfailSummaryByAcademicYearExamidStudentList.forEach(element => {
            var temp: any = [
                element.classConfigName,
                element.totalStudents,
                element.participatedInExam,
                element.totalPass,
                element.totalFail,
                element.passPercentage,
                element.failPercentage,
            ];
            rows.push(temp);
        });


        let first = doc.autoTable.previous;
        doc.autoTable([
            { title: "", dataKey: "b1" },
            { title: "", dataKey: "b2" },
            { title: "", dataKey: "b3" },
            { title: "", dataKey: "b4" },
        ], [
            {
                b1: "Academic Year",
                b2: $(".yearSelect").text(),
                b3: 'Exam',
                b4: $(".examSelectx").text(),
            }
        ], {
            startY: 45,
            showHeader: "never",
            theme: 'grid',

            // addPageContent: pageContent,
        });
        doc.autoTable(col, rows, {
            startY: doc.autoTable.previous.finalY + 5,
            showHeader: "firstPage",
            theme: 'grid',
            headerStyles: {
                // fillColor: [105, 105, 105],
                // textColor: [255, 255, 255],
                // fontSize: 10
                lineWidth: .01,
                lineColor: [224, 224, 224]
            },
            styles: {
                overflow: 'linebreak',
                columnWidth: 'noWrap',
            },
            columnStyles: {

            },


        });


        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }
        doc.setPage(1 + doc.internal.getCurrentPageInfo().pageNumber - doc.autoTable.previous.pageCount);
        doc.save(details + ".pdf");

    }

    const failedExamReport = (value) => {
        let postData: any = {
            examId: value.selectExam,
            academicYear: value.sectionYear,
        }
        fetchPassFailSummaryByAcademicYearExamidStudentList(postData);
    }

    // const onClassChange = (value) => {
    //     fetchSectionWiseFailedExamListByClassAndClassId(value);

    // }



    return (
        <>
            <Card title="Section Wise Pass Fail Summary">
                <Row>
                    <Col xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} md={{ span: 24 }} lg={{ span: 16, offset: 4 }} xl={{ span: 16, offset: 4 }}>
                        <Form
                            layout="vertical"
                            id="sessionYearInfo"
                            onFinish={failedExamReport}
                            form={examReportSectionWiseResultForm}
                        >
                            <Row>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }} xl={{ span: 10 }}>
                                    <Form.Item
                                        name="sectionYear"
                                        label="Select Year"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please select year" },
                                        ]}
                                    >
                                        <SelectAcademicYear />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 10 }} xl={{ span: 10 }}>
                                    <Form.Item
                                        name="selectExam"
                                        label="Select Exam"
                                        className="title-Text"
                                        rules={[
                                            { required: true, message: "Please select exam" },
                                        ]}
                                    >
                                        <Select placeholder="Exam List" style={{ width: "100%" }} className="examSelectx">
                                            {examPassFailSummaryExamList ? (
                                                examPassFailSummaryExamList.map((type, idx) => (
                                                    <Option key={type.id} value={type.id}>
                                                        {type.name}
                                                    </Option>
                                                ))
                                            ) : (
                                                <Option value="fetching">Fetching exam</Option>
                                            )}
                                        </Select>

                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 4 }} xl={{ span: 4 }}>
                                    <Button type="primary" htmlType="submit" icon={<SearchOutlined />} >
                                        Search
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                < Skeleton loading={loading} paragraph={{ rows: 10 }} />
                <Row style={{ display: passfailSummaryByAcademicYearExamidStudentList.length > 0 ? '' : 'none' }}>
                    <Col xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} md={{ span: 24 }}>
                        <TableView
                            antTableProps={{
                                showHeader: true,
                                columns: unassignedSubjectMarkListColumn,
                                rowKey: "subjectSerial",
                                dataSource: passfailSummaryByAcademicYearExamidStudentList,
                                filterData: passfailSummaryByAcademicYearExamidStudentList,
                                pagination: true,
                                bordered: true
                            }}
                            mobileBreakPoint={768}
                        />
                        <br />
                        <Button type="primary" htmlType="submit" icon={<DownloadOutlined />} onClick={() => exportPdf()} className="float-right">Download</Button>
                    </Col>
                </Row>
            </Card>
        </>
    )

}